import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableHsCodePreFilled = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableHsCodePreFilled);
};
